import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=533f25c1&scoped=true"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Multiselect.vue?vue&type=style&index=1&id=533f25c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f25c1",
  null
  
)

export default component.exports